import React from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
`;

const ItemWithVariant = ({ itemVariant }) => {
  const discountTypeOptions = [
    { value: 'PERCENTAGE', label: '% rate' },
    { value: 'PRICE', label: 'flat rate' },
  ];

  const discountType = itemVariant.type
    ? discountTypeOptions.find(ele => ele.value === itemVariant.type)
    : discountTypeOptions[0];

  const discountValue = itemVariant.value || 0;

  return (
    <>
      <Container>
        <Column size={2}>{itemVariant.variant_name}</Column>
        <Column size={10} style={{ fontSize: '13px' }}>
          <Column.Group>
            <Column size={2}>
              ${parseFloat(itemVariant.variant_price || 0).toFixed(2)}
            </Column>
            <Column size={2} style={{ paddingTop: '8px' }}>
              {discountType.label}
            </Column>
            <Column size={2}>
              {discountType?.value === 'PRICE'
                ? `$${discountValue}`
                : `${discountValue}%`}
            </Column>
            <Column size={2}>
              ${parseFloat(itemVariant.new_price).toFixed(2)}
            </Column>
            <Column size={2}>
              ${parseFloat(itemVariant.savings).toFixed(2)}
            </Column>
          </Column.Group>
        </Column>
      </Container>
    </>
  );
};

export default ItemWithVariant;
